@import 'mixins';

$row-width: 460px;
$avatar-width: 40px;
$actions-width-default: 85px;
$contact-row-height: 40px;
$contact-search-row-height: 55px;
$contact-row-height-softphone: 30px;
$contact-search-row-height-softphone: 50px;
$agent-contact-list-offset: 170px;
$agent-contact-list-offset-without-widget: 135px;

.contact-list {
  &__loader {
    margin: auto;
  }

  &__container {
    height: 100%;
    overflow-x: hidden;
    display: grid;
    grid-auto-rows: $contact-row-height;
    grid-row-gap: 20px;
    grid-template-columns: 1fr;

    @include scrollable-container;

    // Accounts for the overflow hover state on each contact
    padding-top: 10px;
    margin-top: -10px;

    /* SCSS variables can't be assigned to CSS variables without string interpolation, because reasons??? */
    --actions-width: #{$actions-width-default};

    &--searching {
      grid-auto-rows: $contact-search-row-height;
    }

    &--softphone {
      margin-top: 0;
      width: calc(100% + 10px);
      margin-left: -10px;
      padding-left: 10px;
    }

    &--softphone:not(&--searching) {
      grid-auto-rows: $contact-row-height-softphone;
    }

    &--softphone.contact-list {
      &__container {
        &--searching {
          grid-auto-rows: $contact-search-row-height-softphone;
        }
      }
    }

    &__loader {
      margin: 0 auto;
      grid-column: 1 / -1;
    }
  }
}

// Structure is slightly different for agentContactList
.agent-contact-list {
  &__container {
    flex: 1;
    min-height: 0;
    overflow-x: hidden;

    @include scrollable-container;

    // Accounts for the overflow hover state on each contact
    padding-top: 10px;
    margin-top: -10px;

    &__internal {
      width: calc(100% + 10px);
      display: grid;
      grid-auto-rows: $contact-row-height;
      grid-row-gap: 20px;
      grid-template-columns: 1fr;
      position: relative;

      /* SCSS variables can't be assigned to CSS variables without string interpolation, because reasons??? */
      --actions-width: #{$actions-width-default};

      &__loader {
        margin: 0 auto;
      }
    }

    &--softphone {
      &__internal {
        margin-top: 0;
        width: calc(100% + 10px);

        padding-left: 10px;
        grid-auto-rows: $contact-row-height-softphone;
        grid-template-columns: 1fr;
      }
    }

    &--drawer {
      flex: none;
      height: calc(100vh - $agent-contact-list-offset);

      &__no-widget {
        height: calc(100vh - $agent-contact-list-offset-without-widget);
      }

      &__not-softphone {
        flex: 1;
      }
    }
  }
}
